class AdminLogs {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.exportNotCustomCsv();
        this.exportCustomCsv();
    }
    downloadFile(url, fileName, dismissModal = null, submitButton = null){
        let hideModal = function () {
            if(!dismissModal && !submitButton){
                bootstrap.Modal.getInstance(document.getElementById('loading-modal')).hide();
            } else {
                new DismissModal(dismissModal).enable();
                bootstrap.Modal.getInstance(document.getElementById(dismissModal)).hide();
                submitButton.setAttribute('data-kt-indicator', 'off');
                submitButton.disabled = false;
            }
        }

        if(!dismissModal && !submitButton){
            new bootstrap.Modal(document.getElementById('loading-modal')).show();
        }
        $.ajax({
            url: url,
            method: 'GET',
            xhrFields: {
                responseType: 'blob'
            },
            success: function (data) {
                const a = document.createElement('a');
                const url = window.URL.createObjectURL(data);
                a.href = url;
                a.download = fileName;
                document.body.append(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                hideModal();
                toastr.success('Admin Logs have been successfully downloaded!')
            },
            error: function (request, status, error) {
                hideModal();
                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.')
            }
        });
    }
    exportNotCustomCsv(){
        let thisClass = this;
        $(document).on('click','.admin-logs-toolbar .export_admin_logs_csv',function(){
            const selectedDuration = $(this).attr('data-get');
            if(selectedDuration === "thisMonth" || selectedDuration === "lastMonth"){
                thisClass.downloadFile("/admin-logs/get-admin-logs-csv-export?duration="+selectedDuration+"&organizationID="+thisClass.organizationID, 'admin-logs.csv');
            }
        });
    }
    exportCustomCsv(){
        let thisClass = this;
        let form = document.getElementById('frm-exportAdminLogsCustomCsvForm-exportAdminLogsCustomCsvForm');
        if(form){
            this.initDateRangePicker("#admin_logs_custom_csv_modal input[name=dateRange]");
            let submitButton = document.getElementById('admin_logs_custom_csv_modal_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'dateRange': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                callback: {
                                    message: 'The value is not a valid date range',
                                    callback: function (input) {
                                        const value = input.value;
                                        const m = moment(value, 'MMM D, YYYY - MMM D, YYYY', true);
                                        return m.isValid();
                                    },
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            );

            const submitForm = () => {
                if (validator) {
                    validator.validate().then(function (status) {
                        if (status === 'Valid') {
                            new DismissModal('admin_logs_custom_csv_modal').disable();
                            submitButton.setAttribute('data-kt-indicator', 'on');
                            submitButton.disabled = true;
                            let dateRange = form.querySelector('input[name=dateRange]').value;
                            const dates = dateRange.split(" - ");
                            thisClass.downloadFile("/admin-logs/get-admin-logs-csv-export?duration=customRange&from="+dates[0]+"&to="+dates[1]+"&organizationID="+thisClass.organizationID,
                                'admin-logs.csv', 'admin_logs_custom_csv_modal', submitButton);
                        }
                    });
                }
            }

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                // Validate form before submit
                submitForm();
            });

            form.addEventListener("submit", function(e) {
                // Prevent default button action
                e.preventDefault();
                // Validate form before submit
                submitForm();
            }, true);
        }
    }
    initDateRangePicker(el){
        const dateEl = $(el);

        let start = moment().startOf('isoWeek');
        let end = moment().endOf('isoWeek');

        function formatDate(start, end) {
            dateEl.html(start.format("MMM D, YYYY") + " - " + end.format("MMM D, YYYY"));
        }

        dateEl.daterangepicker({
            startDate: start,
            endDate: end,
            locale: {
                format: "MMM D, YYYY"
            },
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "This Week": [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                "Last Week": [moment().startOf('isoWeek').subtract(7, "days"), moment().endOf('isoWeek').subtract(7, "days")],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            }
        }, formatDate);
        formatDate(start, end);
    }
}
window.AdminLogs = AdminLogs;